import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia' // ✅ importar pinia

import 'flowbite'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'admin-lte/dist/css/adminlte.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/tailwind.css'
import 'admin-lte/dist/css/adminlte.min.css'


// 🔧 Crear app y registrar pinia ANTES de mount
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)  // ✅ registra pinia aquí
app.use(router)
app.mount('#app')
